/* eslint-disable simple-import-sort/imports */
import moment from "moment";
import "moment-timezone/builds/moment-timezone-with-data-10-year-range";

window.moment = moment;
